import { createReducer } from '@reduxjs/toolkit';
import { getUsersWithScope } from '../actions/scopedUsers';
const initialState = {};
export const scopedUsers = createReducer(initialState, builder => {
  builder.addCase(getUsersWithScope.fulfilled, (state, action) => {
    state[action.payload.scope] = action.payload.userIds;
  });
});